export class ApiError extends Error {
    message: string
    userFriendly = true

    constructor(message: string) {
        super(message)
        this.message = message;
    }
  }